import { useSelector } from 'react-redux'

import { getAuthUserId } from '../../../../data/auth/authSelectors'
import { RTKQueryHook, RTKQueryResultType } from '../../../../data/baseApi'
import { useGetClientsQuery } from '../ltClientsApi'

export const useClientsData: RTKQueryHook<typeof useGetClientsQuery> = (args, opts) => {
  const userId = useSelector(getAuthUserId)
  return useGetClientsQuery(
    {
      providerId: userId,
      status: 'active',
      ...args,
    },
    opts,
  ) as RTKQueryResultType<typeof useGetClientsQuery>
}
